import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useQuery from '../../modules/react/hooks/useQuery';
import useMutation from '../../modules/react/hooks/useMutation';
import Component from '../components/HostnameCertSettingsStatusPanelUploadModal';

const GET_CERTIFICATE = gql`
  query GetCertificate($id: String!) {
    hostname(id: $id) {
      id
      certificate {
        ...HostnameCertSettingsStatusPanelUploadModalCertificate
      }
    }
  }

  ${Component.fragments.certificate}
`;

const UPLOAD_CERTIFICATE = gql`
  mutation UploadCertificate($hostnameId: ID!, $certificate: String!, $key: String!) {
    certificateUpload(hostnameId: $hostnameId, certificate: $certificate, key: $key) {
      success
      userErrors {
        ...HostnameCertSettingsStatusPanelUploadModalUserError
      }
    }
  }

  ${Component.fragments.userError}
`;

const propTypes = {
  hostnameId: PropTypes.string.isRequired,
};

const defaultProps = {};

const SUCCESS_MESSAGE = 'External certificate successfully uploaded';

const HostnameCertSettingsStatusPanelUpload = ({ hostnameId, ...rest }) => {
  const { data: certificateData } = useQuery(
    GET_CERTIFICATE,
    { variables: { id: hostnameId } },
  );

  const [uploadCertificate, { data, error, loading }] = useMutation(
    UPLOAD_CERTIFICATE,
    { refetchQueries: [{ query: GET_CERTIFICATE, variables: { id: hostnameId } }] },
  );

  if (!certificateData) {
    return null;
  }

  const { certificate } = certificateData?.hostname || {};

  const onSave = (certContent, keyContent) => uploadCertificate({
    variables: {
      certificate: certContent,
      hostnameId,
      key: keyContent,
    },
  });

  const submitErrors = data?.certificateUpload?.userErrors || [];

  if (error) {
    submitErrors.push({ code: 0, message: 'Could not upload external certificate' });
  }

  return (
    <Component
      certificate={certificate}
      loading={loading}
      onSave={onSave}
      submitErrors={submitErrors}
      successMessage={data?.certificateUpload?.success ? SUCCESS_MESSAGE : null}
      {...rest}
    />
  );
};

HostnameCertSettingsStatusPanelUpload.propTypes = propTypes;
HostnameCertSettingsStatusPanelUpload.defaultProps = defaultProps;

export default HostnameCertSettingsStatusPanelUpload;
